module.exports = __webpack_public_path__ + "static/img/10-01.43ab077.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/newsDetail/10-01.png
// module id = AS3m
// module chunks = 1